'use strict';

var _main = require('./src/lib/main.js');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _main2.default; // we need to export using commonjs for ease of usage in all
// JavaScript environments

/* eslint-disable import/no-commonjs */



//////////////////
// WEBPACK FOOTER
// ../node_modules/instantsearch.js/dist-es5-module/index.js
// module id = 863
// module chunks = 20 21 22 23 24 25 26 27 28